// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"E6-z","colorTextValue":"F6-z","swatches":"G6-z","collapseLink":"H6-z","isCollapsed":"I6-z","dropdown":"J6-z","disabled":"K6-z"};